import * as CONSTANTS from "./constants";

export const video_curated_playlist_update = (payload) => {
    return {
        type: CONSTANTS.VIDEO_CURATED_PLAYLIST_UPDATE,
        payload: payload,
    };
};

export const video_curated_playlist_null = () => {
    return {
        type: CONSTANTS.VIDEO_CURATED_PLAYLIST_NULL,
        payload: null,
    };
};
